import React from "react";
import { resourcesFiles } from "../../../helpers/backend_helper";

const Columns = (addUpd, destroy, setModalFile, authUser) => {
  const getFiles = (id) => {
    let params = { params: { relation: "unit", id: id, field: "unit_id" } };
    resourcesFiles("get", params).then((response) => {
      console.log(response);
      setModalFile({ show: true, id: id, items: response.files });
    });
  };

  let columns = [
    {
      id: "number",
      name: "Unidad",
      selector: (row) => row.number,
      sortable: true,
    },
    {
      id: "type",
      name: "Tipo",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      id: "plates",
      name: "Placas",
      selector: (row) => row.plates,
      sortable: true,
    },
    {
      id: "fuel_type",
      name: "Combustible",
      selector: (row) => row.fuel_type,
      sortable: true,
      width: "120px",
    },
    {
      id: "concessionary",
      name: "Concesionario",
      selector: (row) => row.concessionary?.name ?? '',
      sortable: false,
    },
    {
      id: "files",
      name: "Documentación",
      width: "100px",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Listado de Archivos"
              onClick={() => getFiles(row.id)}
            >
              <i className="fa fa-folder-open"></i>
            </button>
          </div>
        </div>
      ),
    },
    {
      id: "actions",
      name: "Acciones",
      width: "15%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar Unidad"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
          <div className="p-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar Unidad"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];

  if (authUser.profile_id == 2) {
    columns = [
      {
        id: "ruta",
        name: "Ruta",
        selector: (row) => row.route.name,
        sortable: true,
        wrap: true,
      },
      ...columns,
    ];
  }

  return columns;
};

export default Columns;

//vaneton beicli
